import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "preload-images" }
const _hoisted_2 = ["src"]

import { onMounted, watch, computed } from "vue";
import LegendBar from './components/LegendBar.vue';
import AttractorState from "./components/AttractorState.vue";
import { useIdle } from "@vueuse/core";
import useStore, { Languages, PageTransitions } from './store/useStore'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()

const { idle } = useIdle(1 * 120 * 1000, {
  events: ["touchstart", "click"],
}); // 2 min

const showAttractor = computed(() => idle.value && store.isElectron)
watch(idle, (idleValue) => {
  if (!store.isElectron) return
  if (idleValue) {
    store.pageTransitionName = PageTransitions.PAGE
    store.setLanguage(Languages.IN)
    store.goToIntro()
  } 
  // else {
  //   store.resetExperience()
  //   store.pageTransitionName = PageTransitions.PAGE
  // }
})

let pausedVideo = "";
const preloadImages = [
  "ui/texture-bg.png",
  "onboarding/lockup.svg",
  "ishaan/ishaan-baby.png",
  "joy/joy-baby.png",
  "magda/magda-baby.png",
  "matteo/matteo-baby.png",
  "jie-li-pan/jie-li-pan-baby.png",
  "meydi/meydi-baby.png",
  "olivia/olivia-baby.png",
  "samroze/samroze-baby.png",
  "tait/tait-baby.png",
  "ishaan/ishaan-baby-shadow.png",
  "joy/joy-baby-shadow.png",
  "magda/magda-baby-shadow.png",
  "matteo/matteo-baby-shadow.png",
  "jie-li-pan/jie-li-pan-baby-shadow.png",
  "meydi/meydi-baby-shadow.png",
  "olivia/olivia-baby-shadow.png",
  "samroze/samroze-baby-shadow.png",
  "tait/tait-baby-shadow.png",
];

const initSleepPause = () => {
  // https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
  // Set the name of the hidden property and the change event for visibility
  let hidden;
  let visibilityChange;
  if (typeof (document as any).hidden !== "undefined") {
    // Opera 12.10 and Firefox 18 and later support
    hidden = "hidden";
    visibilityChange = "visibilitychange";
  } else if (typeof (document as any).msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
  } else if (typeof (document as any).webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
  }

  // If the page is hidden, pause the video;
  // if the page is shown, play the video
  function handleVisibilityChange() {
    if (document[hidden]) {
      Array.from(document.getElementsByTagName("video")).forEach((video) => {
        if (!video.paused) {
          pausedVideo = video.id;
          video.pause();
        }
      });
    } else {
      if (pausedVideo !== "") {
        const video = document.getElementById(pausedVideo) as HTMLVideoElement;
        if (video) video.play();
        pausedVideo = "";
      }
    }
  }

  // Warn if the browser doesn't support addEventListener or the Page Visibility API
  if (
    typeof document.addEventListener === "undefined" ||
    hidden === undefined
  ) {
    console.log(
      "This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API."
    );
  } else {
    // Handle page visibility change
    document.addEventListener(visibilityChange, handleVisibilityChange, false);
  }
};
onMounted(() => initSleepPause());


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LegendBar),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        _createVNode(_Transition, {
          name: _unref(store).pageTransitionName || 'page',
          mode: "out-in",
          appear: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: route.path
            }))
          ]),
          _: 2
        }, 1032, ["name"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(preloadImages, (image) => {
        return _createElementVNode("img", {
          src: require(`@/assets/images/${image}`),
          key: image
        }, null, 8, _hoisted_2)
      }), 64))
    ])
  ], 64))
}
}

})